import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Stand, UserSnippet } from "../../../../data/interfaces";
import UsersList from "../../../../components/users/list";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  stand: Stand;
  team: UserSnippet[];
  onAppointment?: any;
}

const StandDetailTeamTabView = ({ stand, team, onAppointment, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[StandDetailTeamTabView] init");
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[StandDetailTeamTabView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className={"panel-content team"}>
      {team.length > 0 ? (
        <UsersList
          users={team}
          showEmail={true}
          showRole={true}
          showAddToContacts={true}
          showPhone={true}
          showChat={true}
          showGetAppointment={true}
          onAppointment={onAppointment}
        />
      ) : (
        <span>{t("pages.standDetail.tabs.noData")}</span>
      )}
    </div>
  );
};
export default StandDetailTeamTabView;
